<template>

<div>
  <div id='main'>
    <div id='content' class='column' style=''>  

    <div class='message' id='logoutMessageDiv' v-if="logoutMessage" style='margin:10px;height:55px;background:#ff9900;' >
      <h1>Du kommer strax loggas ut</h1>
     
    </div>

    <div class='message' id='activated' :style="activatedDivVisible ? {'display' : 'block'} : {'display': 'none'}"  @click="activatedDivVisible = false" >
      <h1>Ditt konto är aktiverat!</h1>
      <br/>Nu är tjänsten aktiverad! Om du har lagt in ett registeringsnummer kan du prova att skicka en manuell förfrågan till Transportstyrelsen genom att klicka på "SKICKA FÖRFRÅGAN" nedan. Annars sker detta automatiskt innan nästa månadsskifte.<br/><br/>
    </div>

    <transition name="fade">
    <div class="message" style='margin:10px;' v-if="loginFail.length > 0" :style="loginFail.length > 0 ? {'background': 'red'} : {'background': 'green'}"><h1>{{ loginFail }} </h1><br/><br/>Gå till <router-link to="/">startsidan</router-link> för att beställa nya inloggningsuppgifter.<br><br>Vid inloggningsproblem  <router-link to="/contact">kontakta oss</router-link>.</div>
    </transition>

    <div id='user' :style="name.length > 0 ? {'display' : 'block'} : {'display': 'none'}">
    <h1 style='float:left;' title=''>Personuppgifter </h1> 
    <button v-on:click="actionDialog('logout')" style='float:right;'>LOGGA UT</button>
    
    
    <br><br>
    <input type="text" v-model="name" placeholder="Ditt namn" /><br>
    <input type="text" v-model="email" placeholder="Din e-post" /><br>
    <h3>{{ accountExpire }} </h3><br>
    <button v-on:click="update(this)" >SPARA PERSONUPPGIFTER</button><br><br>
    <div style='height:45px;'>
    <transition name="fade">
    <div class="message" v-if="personalResult.length > 0" @click="personalResult = ''" :style="personalResultError ? {'background': 'red'} : {'background': 'green'}"> {{ personalResult }} </div>
    </transition>
    </div>

    <h1>Dina fordon</h1>
    <input type="text" v-model="regId" style='width:50%;margin-bottom:0px;' placeholder="Registeringsnummer" />&nbsp;&nbsp;<button v-on:click="addCar">LÄGG TILL</button>
    <div class='messageWrapper'>
    <transition name="fade">
    <div class="message" v-if="carResult.length > 0" @click="carResult = ''" :style="carResultError ? {'background': 'red'} : {'background': 'green'}"> {{ carResult }} </div>
    </transition>
    </div >
<br>
    <table border='0' id='carList'>
      <tr>
          <td class='trash'></td>
          <td><b>Fordon</b></td>
          <td><b>Senaste förfrågan</b></td>
          <td style='width:250px;'></td>
      </tr>
      <tr v-for="car in carList" :key="car.regId" >
          <td><img v-on:click="deleteCarDialog(car)" src='./assets/trash.png'  /></td>
          <td><h3>{{ car.regId }} </h3></td>
          <td><h3>{{ car.mailDate }} </h3></td>
          <td align='right' v-if="car.allowMail"><button v-on:click="mailCarDialog(car)" >SKICKA FÖRFRÅGAN</button></td>
          
      </tr>
      <tr><td></td><td colspan='3'>Du kan maximalt skicka en förfrågan per dygn och fordon</td></tr>
    </table>




    <div id='payment'>
    <img alt="20kr per år" src="./assets/pricetag.png" style='width:100px;height:auto;float:right;'>
    <h1 >Förläng prenumerationen! </h1>
    
    Förläng prenumerationen med ett år genom att klicka nedan. Du betalar via Swish och när vi har tagit emot din betalning så får du ett mail. Vi brukar godkänna betalningar och förlänga konton i mitten av månaden så det kan ta någon vecka innan du får bekräftelsemailet. <br><br>
    <button v-on:click="paymentDialog()" >FÖRLÄNG PRENUMERATIONEN ETT&nbsp;ÅR:&nbsp;20&nbsp;kr</button><br><br>

    <div style='height:45px;'>
    <transition name="fade">
    <div class="message" v-if="paymentResult.length > 0" @click="paymentResult = ''" :style="paymentResultError ? {'background': 'red'} : {'background': 'green'}"> {{ paymentResult }} </div>
    </transition>
    </div>

    <h3>Betalningshistorik</h3>
    <table border='0' id='paymentList'>
      <tr>
          
          <td><b>ID</b></td>
          <td class='hideOnPhone'><b>Orderdatum</b></td>
          <td><b>Betaldatum</b></td>
          <td><b>Belopp</b></td>
      
      </tr>
      <tr v-for="payment in paymentList" :key="payment.id" >
          
          <td><h3>{{ payment.id }} </h3></td>
          <td class='hideOnPhone'><h3>{{ payment.sentDate }} </h3></td>
          <td><h3>{{ payment.recivedDate }} </h3></td>
          <td><h3>{{ payment.amount }} </h3></td>

          <td v-if="payment.recivedDate.length > 9" align='right'><h3><a v-bind:href=" '' + hostname + '/receipt/' + $route.params.token + '/' + payment.id" target='_blank'>Visa kvitto</a> </h3></td>

      </tr>
    </table>

    <div class='message' v-if="pendingPayment">
      
      <img src='./assets/swish-logo.png' style='max-width:200px;height:auto;width:100%;margin-bottom:10px;'/><br/>
      Swish:  <b>{{ swishNo }}</b> {{ swishLabel }} <br>
      Märkning:  <b>{{ paymentKey }}</b><br><br>
      
      <img :src="this.$hostname + '/qr/' + $route.params.token + '/'" style='border-radius:10px;max-width:150px;width:100%;height:auto;margin-bottom:10px;'  />
      <br>Starta Swish-appen och scanna QR-koden.

      <div style='clear:both;'></div>
    </div>
</div> <!-- payment -->

<br>
    <br>
    <button v-on:click="actionDialog('deleteAccount')" style='background:red;'>AVSLUTA KONTO</button><br><br>
  </div>



        
      
    </div>
  </div>
  

</div>
</template>

<script>


import validator from './components/mixins/email'

const axios = require('axios');

export default {
  name: 'User',
  props: {
  },
    mixins: [validator],

data: function () {
  return {
    name: "",
    email: "",
    regId: "",
    carList: [],
    paymentList:[],
    personalResult: "",
    carResult: "",
    paymentResult: "", 
    paymentKey: "",
    swishNo: "",
    swishLabel: "",
    show: false,
    personalResultError: false, 
    carResultError: false,
    paymentResutError: false,
    token: "",
    loginFail: "",
    accountExpire : "",
    userVersion: "",
    activatedDivVisible: false,
    pendingPayment: false,
    timer: false,
    timerAuto: false,
    logoutMessage: false,
    hostname: this.$hostname,
    storeOpen: false
  }
},
    methods: {
        cancel: function(){

        },
        update: async function () {
  
            if (this.name.length < 3){
                this.personalResultError = true;
                this.personalResult = "Ange ett namn på minst tre tecken";
                return;
            }

            if (!this.validateEmail(this.email)){
                this.personalResultError = true;
                this.personalResult = "Ogiltig epost";
                return;
            }


            axios.post(this.$hostname + '/user/', {
            
                        token: this.$route.params.token,
                        name:this.name,
                        email:this.email
                        //regnr:this.regnr
                    
            })
            .then(response => {

                this.handlePersonalResponse(response);
                
            })
            .catch(error =>  {
              
                alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        },
        paymentDialog: function(){

          if (!this.storeOpen){
            this.$dialog.alert('Vi kommer öppna betalningstjänsten under Maj så återkom då.', {okText: "OK", animation: 'fade', backdropClose: true}).then(function(dialog) {
      
            });
            return;
          }
          var that = this;

          this.$dialog
            .confirm("Vill du förlänga prenumerationen med ett år för 20 kr?", {okText: 'OK', cancelText: 'STÄNG', animation: 'fade', backdropClose: true})
            .then(function(dialog) {
              that.payment();
            })
            .catch(function() {
              return;
            });

        },
        payment: async function () {
  
            //window.confirm = null;
            //window.alert = null;

            if (!this.storeOpen){
              window.alert("Vi kommer öppna betalningstjänsten under Maj så återkom då. ");
              return;
            }

            /*if (!window.confirm("Vill du förlänga prenumerationen med ett år för 20 kr?")){
              return;
            }*/

            axios.post(this.$hostname + '/user/', {
            
                        token: this.$route.params.token,
                        addPayment: 20
                    
            })
            .then(response => {

                this.handlePaymentResponse(response);
                
            })
            .catch(error =>  {
               
                alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        },
        getData: async function () {

          axios.get(this.$hostname + '/user/' + this.$route.params.token,)
            .then(response => {

              if (response.data == ""){

                alert("Kunde inte hämta data. Beställ nya inloggningsuppgifter eller kontakta supporten");
                
              }
              this.handlePersonalResponse(response); 
            })
            .catch(error =>  {
               
                alert("FAIL " + error);
            });   
        },
        deleteCarDialog: function(car){
            
          var that = this;

          this.$dialog
            .confirm("Vill du radera " + car.regId + "?", {okText: 'OK', cancelText: 'STÄNG', animation: 'fade', backdropClose: true})
            .then(function(dialog) {
              that.deleteCar(car);
            })
            .catch(function() {
              return;
            });
          
        },
        deleteCar: async function (car) {

            axios.post(this.$hostname + '/user/', {
            
                        token: this.$route.params.token,
                        deleteCarId:car.id,
                        
                        //regnr:this.regnr
                    
            })
            .then(response => {

                this.handleCarResponse(response);
                
            })
            .catch(error =>  {
                
                alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        },
        addCar: async function () {
  
            this.regId = this.regId.replace(/ /g, '');

            if (this.regId.length != 6){
                this.carResultError = true;
                this.carResult = "Ange ett regnummer på exakt sex tecken";
                return;
            }

            axios.post(this.$hostname + '/user/', {
            
                        token: this.$route.params.token,
                        addRegId:this.regId,
                    
            })
            .then(response => {

                this.handleCarResponse(response);
                
            })
            .catch(error =>  {
               
               alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        },
        mailCarDialog: function(car){
            
          var that = this;

          this.$dialog
            .confirm("Vill du skicka en förfrågan till Transportstyrelsen gällande trängselskatt för fordon: " + car.regId + "?", {okText: 'OK', cancelText: 'STÄNG', animation: 'fade', backdropClose: true})
            .then(function(dialog) {
              that.mailCar(car);
            })
            .catch(function() {
              return;
            });
          
        },
        mailCar: async function (car) {
  


            axios.post(this.$hostname + '/user/', {
            
                        token: this.$route.params.token,
                        mailCarId:car.id,
                    
            })
            .then(response => {

                this.handleCarResponse(response);
                
            })
            .catch(error =>  {
               
                alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        },
        actionDialog(actionName){
          var message = "??";
          var options = {okText: 'OK', cancelText: 'STÄNG', animation: 'fade', backdropClose: true};
          if (actionName == "logout"){
            message = "Vill du logga ut?"
          }

          if (actionName == "deleteAccount"){
            message = "Vill du radera ditt konto? Om du ångrar dej får du börja om och registrera ditt konto igen."
            options.okText = "JA - AVSLUTA KONTO";
          }

          var that = this;

          this.$dialog
            .confirm(message, options)
            .then(function(dialog) {
              that.action(actionName);
            })
            .catch(function() {
              return;
            });
        },
        action: async function (actionName) {


            axios.post( this.$hostname + '/user/', {
            
                        token: this.$route.params.token,
                        action:actionName,
                    
            })
            .then(response => {

                this.handlePersonalResponse(response);
                
            })
            .catch(error =>  {
               
                alert("FAIL " + error);
                this.result = "FAIL"
                
            });   
        },
        
        handlePaymentResponse(response){


          if (response.data.status == "OK"){

              if (response.data.user){
                this.handleUser(response.data.user);
              }
              
              this.paymentResult = response.data.message;
              this.paymentResultError = false;

              var that = this;

              if (this.paymentResult.length > 0){
                setTimeout(function(){ that.paymentResult = ""; }, 1500);
              }

          }else if (response.data.status == "LOGINFAIL"){
              
              this.handleLoginFail(response);  
          }else if (response.data.status == "FAIL"){

              this.paymentResult = response.data.message;
              this.paymentResultError = true;
          }else{
              this.paymentResult = "Kunde inte spara UI: " + response.data;
              this.paymentResultError = true;
          }

        }, 


        handlePersonalResponse(response){


          if (response.data.status == "OK"){

              if (response.data.user){
                this.handleUser(response.data.user);
              }
              
              this.loginFail = "";
              this.personalResult = response.data.message;
              this.personalResultError = false;

              var that = this;

              if (this.personalResult.length > 0){
                setTimeout(function(){ that.personalResult = ""; }, 1500);
              }

                this.activatedDivVisible = response.data.activated;



          }else if (response.data.status == "LOGINFAIL" || response.data.status == "LOGOUT" || response.data.status == "DELETED"){
              this.logoutMessage = false;
              this.handleLoginFail(response);
              
          }else if (response.data.status == "FAIL"){

              this.personalResult = response.data.message;
              this.personalResultError = true;
          }else{
              //console.log(response);
              this.personalResult = "Kunde inte spara UI: " + response.data;
              this.personalResultError = true;
          }

        }, 
        handleCarResponse(response){
            
          if (response.data.status == "OK"){
                        
              this.regId = "";

              if (response.data.user){
                this.handleUser(response.data.user);
              }
              
              this.loginFail = "";
              this.carResult = response.data.message;
              this.carResultError = false;

              var that = this;

              if (this.carResult.length > 0){
                setTimeout(function(){ that.carResult = ""; }, 1500);
              }



          }else if (response.data.status == "LOGINFAIL"){
              this.loginFail = response.data.message + " ";
          }else if (response.data.status == "FAIL"){

              this.carResult = response.data.message;
              this.carResultError = true;
          }else{
              this.carResult = "Kunde inte spara UI: " + response.data;
              this.carResultError = true;
          }

        }, 
        handleUser(user){
          this.name = user.name;
          this.email = user.email;
          this.userVersion = user.version;
          this.accountExpire = user.accountExpire;
          this.carList = user.carList;
          this.paymentList = user.paymentList;
          this.paymentKey = user.paymentKey;
          this.swishNo = user.swishNo;
          this.swishLabel = user.swishLabel;
          this.storeOpen = user.storeOpen;
          this.pendingPayment = user.pendingPayment;

          var sessionSeconds = (user.sessionSeconds -5) * 1000;

          var that = this;

          clearTimeout(this.timerAuto);
          this.timer = setTimeout(function(){ that.localLogout(); }, sessionSeconds);
          this.logoutMessage = false;
        },
        handleLoginFail(response){

          this.loginFail = response.data.message + " ";
          this.name = "";
          this.carList = [];
          this.email = "";
        },
        localLogout(){
          this.logoutMessage = true;
          var that = this
          this.timerAuto = setTimeout(function(){ that.action("autologout")}, 5000);
        }

     },


     
 mounted(){
   //location.reload();
    this.getData();

    
 }

}

//alert(123);



// http://api.mintrangselskatt.se.dev/user/check

</script>



<style scoped>


div#user{
  padding:20px;
  color:white;
}

div#user input{
    margin-bottom:20px;
}

a{
  color:white;
}

h1{
  margin:0px;
  padding:0px;
  margin-bottom:20px;
  display:block;
  padding-top:5px;
  font-size: calc( 14px + 1.5vw );
  
}

div#payment{
  background:#404040;padding:10px;border-radius:10px;
}
div#user table#carList, div#user table#paymentList {
  width:100%;
  margin-bottom:20px;

}

div#user table#carList tr td img{
  width:30px;
  height:auto;
}

div#user table#carList tr td.trash{
  width:35px;
}

div#user table#carList tr td h3, div#user table#paymentList tr td h3{

  font-size: calc(12px + 0.5vw);
  margin-top:10px;
  margin-bottom:10px;
}

div#logoutMessageDiv{
    position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}
div#user table#carList tr td b, div#user table#paymentList tr td b{
  color:grey;
  font-weight:bold;
}
div#user ul li h1{
  top: -10px;
position: relative;
left: 10px;
}
div#user input[type='text']{
  font-size: calc(12px + 0.4vw);
  width: calc(100% - 20px);
  border-radius: 10px;
  border:0px solid transparent;
  padding:10px;
  
}

div#user button{
    font-size: calc(12px + 0.4vw);
    border-radius: 10px;
    background-color:#2196f3;
    color:white;
    padding:10px;
    border:0px solid transparent;
  
}

.hideOnPhone{
  display:none;
}
@media screen and (min-width: 1300px)  {
   
  div#user button{
    font-size: calc(14px + 0.4vw);
    padding-left:20px;
    padding-right:20px;

  
  }

  div#user input[type='text']{
    font-size: calc(14px + 0.4vw);  
  }
  .hideOnPhone{
    display:block;
  }

  div#user table#carList tr td img{
    width:40px;
    height:auto;
  }

  div#user table#carList tr td.trash{
    width:45px;
  }
}



div#activated{
  margin:20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}






</style>

<style>
.dg-btn.dg-btn--cancel{
  background-color:grey;
}

.dg-btn.dg-btn--ok {
  background-color:#2196f3;
  border-color: #2196f3;
  color:white;
}
</style>